import { z } from "zod";

export const reviewInformationSchema = z.object({
  hasTextCommunication: z.enum(["yes", "no"], {
    required_error: "Please select an option",
  }),
  notes: z.string().optional(),
});

export type ReviewInformationFormType = z.infer<typeof reviewInformationSchema>;
